import React, { Component } from "react";

class TestButton extends Component {
  render() {
    return (
      <div className="testbutton">
        <span onClick={this.props.onAddNewTarget} className="startbutton">
          START
        </span>
        <br></br>
        <span className="starttext">Protect Your Transfer From Hackers!</span>
      </div>
    );
  }
}

export default TestButton;
